import { IDonorPreselectNote, ILkdpiInfo, IPreselectDonorInfo, IRecipient, ISingleEpletMmRisk } from '@nkr/models/index';
import { PotentialDonorCategory } from '@nkr/enums/potential-donor-category';
import { DonorPreselectReviewStatus } from '@nkr/enums/donor-preselect-review-status';

/**
 * Identical to the potential-donors row shape by design. The two pre-select pages share list2,
 * grid and the confirm dialogs, so a row from either has to satisfy the same type.
 */
export interface IRowData {
    recipient: IRecipient,
    donor: IPreselectDonorInfo,

    failedAvoids: string[],
    hlaPointsA: number,
    hlaPointsB: number,
    hlaPointsDr: number,
    totalHlaPoints: number,
    isHardBlocked: boolean,

    singleEpletMmRisk: ISingleEpletMmRisk,
    lkdpiInfo: ILkdpiInfo,
    categories: PotentialDonorCategory[],
    isPairedDonor: boolean,
    isFirst: boolean,
    reviewStatus: DonorPreselectReviewStatus,
    donorNote: IDonorPreselectNote,
    matchNote: IDonorPreselectNote,
    bmtMm: number,
    matchOfferId: number,
    isSelected: boolean,
    responseDeadLineDate: string,
    isReviewRequested: boolean,
    reviewRequestedDate: string
}
